import React, { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { unifiedLoginUrl } from './unified';

export default function PrivateRoute({ children }) {
  const { user, loading, sso } = useAuth();
  const location = useLocation();
  const returnTo = location.pathname + location.search + location.hash;
  const redirecting = useRef(false);
  const needsUnifiedLogin = !loading && !user && sso.enabled && !sso.configurationError;
  useEffect(() => {
    if (needsUnifiedLogin && !redirecting.current) {
      redirecting.current = true;
      window.location.replace(unifiedLoginUrl('login', returnTo));
    }
  }, [needsUnifiedLogin, returnTo]);
  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>加载中...</div>;
  if (needsUnifiedLogin) return <div role="status" style={{ padding: 40, textAlign: 'center' }}>正在确认登录状态…</div>;
  return user ? children : <Navigate to={'/login?returnTo=' + encodeURIComponent(returnTo)} replace />;
}
